//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchDetail, fetchDelete } from '@/api/PMS/baseInformation/buildingUnit';
export default {
  props: ['keyValue', 'showDialog'],
  data: function data() {
    return {
      areaId: '',
      childData: {}
    };
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        console.log(1);
        this.init();
      }
    }
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;

      if (this.keyValue > 0) {
        var queryData = {
          id: this.keyValue
        };
        fetchDetail(queryData).then(function (response) {
          _this.childData = response.data.data;
        });
      }
    },
    handleEdit: function handleEdit() {
      this.$emit('handDetailCancle', 'edit');
    },
    delete: function _delete(houseIds) {
      var _this2 = this;

      if (houseIds.length > 0) {
        this.$confirm('你确定是要删除该楼栋单元, 是否继续?', '提示').then(function () {
          fetchDelete(houseIds).then(function (response) {
            _this2.$emit('handDetailCancle', false);

            _this2.Alert({
              alertType: 'delete'
            });
          });
        });
      } else {
        this.Alert({
          alertType: 'nodata'
        });
      }
    },
    handleDelete: function handleDelete() {
      var houseIds = [];
      houseIds.push(this.keyValue);
      this.delete(houseIds);
    }
  }
};